export default __webpack_public_path__ + "static/media/KBank.c68831e6.svg";